import { commonMixins } from '@/mixins/common/commonMixin'
import MessageMixin from '@/mixins/message'
import { claimPayCseStat } from '@/const/claims'
import { expandURI } from '@/utils/ajax'
// import store from '@/store'
export const claimReleaseMixin = {
  data() {
    return {
    }
  },
  computed: {
    claimPayCseStatList() {
      const list = Object.freeze(claimPayCseStat)
      return Object.keys(list).map(key => {
        return {
          label: key + ' - ' + list[key],
          value: key
        }
      })
    }
  },
  methods: {
    async doFetchUnRelClmDoc(branch, tranType1) {
      this.loading = true
      const apiUrl = this.$store.state.clmRel.menu.getunRelClmDoc
      if (apiUrl) {
        const expand = {
          branch: branch,
          tranType1: tranType1
        }
        const result = await this.$http.get(expandURI(apiUrl, expand))
        if (result && result.data) {
          const data = result.data
          if (data) {
            this.$set(this, 'docNoItems', data.dataMap.clmPaytHdrList)
          } else {
            this.$set(this, 'docNoItems', [])
          }
        } else {
          this.$toast.error('Unexpected server response')
        }
      } else {
        this.$toast.error('Missing API URL (fetch claim release txn)')
      }
      this.loading = false
    },
    async getPendingAuthorisation(branch, fund, tranType1, docNo) {
      try {
        const apiUrl = this.$store.state.clmRel.menu.checkPending
        if (apiUrl) {
          const expand = {
            branch: branch,
            fund: fund,
            tranType1: tranType1,
            docNo: docNo
          }
          const result = await this.$http.get(expandURI(apiUrl, expand))
          return result.data.dataMap
        }
      } catch (err) {
        if (err.response && err.response.data) {
          this.notify(err.response.data)
        }
      }
    },
    async checkPendingRecord(branch, fund, tranType1, docNo) {
      try {
        const apiUrl = this.$store.state.clmRel.menu.checkPendingRecord
        if (apiUrl) {
          const expand = {
            branch: branch,
            fund: fund,
            tranType1: tranType1,
            docNo: docNo
          }
          const result = await this.$http.get(expandURI(apiUrl, expand))
          return result.data.dataMap
        }
      } catch (err) {
        if (err.response.data) {
          this.notify(err.response.data)
        }
      }
    }
  },
  mixins: [
    commonMixins,
    MessageMixin
  ]
}

export default claimReleaseMixin
